import { AloDbBase, IAloDbBaseConstParam } from '@/models/alodb/AloDbBase'
import { AloBaseArray } from '@/models/alo/AloBaseArray'

export interface IAloDbGliderConstParam extends IAloDbBaseConstParam {
    GLI_ID:number|null
    GTA_ID:number|null
    IRS_ID:number|null
    GLT_ID:number|null    
    ENS_ID:number|null   
    MMC_ID:number|null 
    MMH_ID:number|null 
    GLI_KEY:string|null
    GLI_LIBELLE:string|null
    GLI_LIBELLE2:string|null
    GLI_DATFAB:string|null
    GLI_NSERIE:string|null    
    GLI_FABRICANT:string|null        
    GLI_PMAX:number|null   
    GLI_BATNRJMAX:number|null

  }

export class AloDbGlider extends AloDbBase {
        
    public GLI_ID:number|null
    public GTA_ID:number|null
    public IRS_ID:number|null   
    public GLT_ID:number|null            
    public ENS_ID:number|null 
    public MMC_ID:number|null 
    public MMH_ID:number|null   
    public GLI_KEY:string|null
    public GLI_LIBELLE:string|null
    public GLI_LIBELLE2:string|null
    public GLI_DATFAB:Date|null
    public GLI_NSERIE:string|null    
    public GLI_FABRICANT:string|null        
    public GLI_PMAX:number|null   
    public GLI_BATNRJMAX:number|null   
    
    constructor({GLI_ID,GTA_ID,IRS_ID,GLT_ID,ENS_ID,MMC_ID,MMH_ID,GLI_KEY,GLI_LIBELLE,GLI_LIBELLE2,GLI_DATFAB,GLI_NSERIE,GLI_FABRICANT,GLI_PMAX,GLI_BATNRJMAX,...args }:IAloDbGliderConstParam = {} as IAloDbGliderConstParam) {
        super(args)
        this.GLI_ID = GLI_ID
        this.GTA_ID = GTA_ID
        this.IRS_ID = IRS_ID
        this.GLT_ID = GLT_ID
        this.ENS_ID = ENS_ID
        this.MMC_ID = MMC_ID
        this.MMH_ID = MMH_ID
        this.GLI_KEY = GLI_KEY        
        this.GLI_LIBELLE = GLI_LIBELLE
        this.GLI_LIBELLE2 = GLI_LIBELLE2
        this.GLI_DATFAB = GLI_DATFAB === null?null:new Date(GLI_DATFAB)  
        this.GLI_NSERIE = GLI_NSERIE
        this.GLI_FABRICANT = GLI_FABRICANT
        this.GLI_PMAX = GLI_PMAX
        this.GLI_BATNRJMAX = GLI_BATNRJMAX
    }

    static createAloDbGliderArray(datas:any) {
        return new AloBaseArray(AloDbGlider,datas)
    }

    static createAloDbGliderWithDetail(data:any) {
        return new AloDbGlider({...data,detailLoaded:true})
    }
}
